/**
 * Shared module (shared.module.ts).
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
// Angular+ Style Guide Components
import { BcComponentsModule } from 'ng-library-style-guide/dist/bc-style-guide';
import { OrderFiltersComponent } from './modals/order-filters/order-filters.component';
import { OrderCustomTabComponent } from './modals/order-custom-tab/order-custom-tab.component';
import { AddressPopoverComponent } from './popovers/address/address-popover.component';
import { UserPopoverComponent } from './popovers/user/user-popover.component';
import { ManageAttachmentsComponent } from './modals/order-pending-attachments/manage-attachments.component';
import { MainPipe } from '../pipes/main-pipe.module';
import { OrderAdjustmentsComponent } from './modals/order-adjustments/order-adjustments.component';
import { ManageLookaheadsComponent } from './modals/order-lookaheads/manage-lookaheads.component';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { BcxPageHeaderComponent } from './bcx-page/bcx-header/bcx-page-header.component';
import { BcxPageFiltersComponent } from './bcx-page/bcx-filters/bcx-page-filters.component';
import { OverridePopoverComponent } from './popovers/override/override-popover.component';
import { AdjustmentsPopoverComponent } from './popovers/adjustments/adjustments-popover.component';
import { ChangeItemStatusDialogComponent } from './modals/viewer-item-status/change-item-status-dialog.component';
import { OrderNotificationsComponent } from './order-notifications/order-notifications.component';
import { OrderAssignmentsComponent } from './modals/order-assignments/order-assignments.component';
import { OrderItemHolesComponent } from './modals/order-item-holes/order-item-holes.component';
@NgModule({
  declarations: [
    AddressPopoverComponent,
    AdjustmentsPopoverComponent,
    BcxPageFiltersComponent,
    BcxPageHeaderComponent,
    ManageAttachmentsComponent,
    OrderAdjustmentsComponent,
    ManageLookaheadsComponent,
    OrderAssignmentsComponent,
    OrderCustomTabComponent,
    OrderFiltersComponent,
    OverridePopoverComponent,
    ReportViewerComponent,
    UserPopoverComponent,
    ChangeItemStatusDialogComponent,
    OrderNotificationsComponent,
    OrderItemHolesComponent,
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NgbModule,
    BcComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MainPipe,
  ],
  exports: [
    AddressPopoverComponent,
    AdjustmentsPopoverComponent,
    BcComponentsModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    NgbModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MainPipe,
    OrderAssignmentsComponent,
    OverridePopoverComponent,
    ReportViewerComponent,
    BcxPageFiltersComponent,
    BcxPageHeaderComponent,
    UserPopoverComponent,
    OrderNotificationsComponent,
  ],
  providers: [MainPipe],
})
export class SharedModule {}

// EOF
